/**
 * Detects if the user has requested that the system minimize the amount of
 * non-essential motion it uses
 *
 * @returns boolean
 */
export function prefersReducedMotion() {
  const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  return mediaQuery && mediaQuery.matches;
}

export function isTouchDevice() {
  return window.matchMedia('(hover: none), (pointer: coarse)').matches;
}
